export default __webpack_public_path__ + "static/media/navigation-Header-2k.083b55cb.jpg";